export type CancellablePromise = {
	cancel: Function;
	promise: Promise<any>;
};

export function cancellablePromise(
	promise: any,
	inputs: any
): CancellablePromise {
	let cancelled = false;

	function cancel() {
		cancelled = true;
	}

	const promiseInProgress = new Promise((resolve, reject) => {
		promise(inputs)
			.then((response: any) => {
				if (cancelled) {
					reject({ cancelled: true });
					return;
				}
				resolve(response);
			})
			.catch((error: any) => {
				reject(error);
			});
	});

	return {
		cancel,
		promise: promiseInProgress,
	};
}
